import { Component, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonCoreModule } from '@fedex/common-core';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { CreateShipmentPageComponent } from './pages/create-shipment-page/create-shipment-page.component';
import { ShippingOptionsPageComponent } from './pages/shipping-options-page/shipping-options-page.component';
import { ProgressBarComponent } from './common/progress-bar/progress-bar.component';
import { PickupConfirmationPageComponent } from './pages/pickup-confirmation-page/pickup-confirmation-page.component';
import { PointShippingConfirmationPageComponent } from './pages/point-shipping-confirmation-page/point-shipping-confirmation-page.component';
import { CaptchaDialogComponent } from './common/captcha-dialog/captcha-dialog.component';
import { CaptchaDialogService } from './services/captcha-dialog.service';
import { ShippingCourierConfirmationPageComponent } from './pages/courier-shipping-confirmation-page/courier-shipping-confirmation-page.component';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    CommonCoreModule,
    MainPageComponent,
    CreateShipmentPageComponent,
    ShippingOptionsPageComponent,
    ProgressBarComponent,
    ShippingCourierConfirmationPageComponent,
    PickupConfirmationPageComponent,
    PointShippingConfirmationPageComponent,
    CaptchaDialogComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  @ViewChild(CaptchaDialogComponent)
  captchaDialogComponent!: CaptchaDialogComponent;

  constructor(private captchaDialogService: CaptchaDialogService) {}

  ngAfterViewInit(): void {
    this.captchaDialogService.setCaptchaDialog(this.captchaDialogComponent);
  }
}
